module.exports = __webpack_public_path__ + "img/Foto_Digiasia_Bios_All_3_TIA.2f856b05.jpeg";